import { includes, filter, length, gt } from 'ramda';
import { buildLabel } from 'src/utilities/naming';
import { SMARTMATCH_TYPE_RATE_APPROVER } from '../constants';

export const USER_ONBOARD_ADMIN = 'admin';
export const USER_ONBOARD_ADMIN_READER = 'admin_reader';
export const USER_ONBOARD_ADVISOR = 'advisor';
export const USER_ONBOARD_ISO = 'iso';
export const USER_ONBOARD_LOAN_PROCESSOR = 'loan_processor';
export const USER_ONBOARD_LOAN_PROCESSOR_READER = 'loan_processor_reader';
export const USER_ONBOARD_LOAN_OFFICER = 'loan_officers';
export const USER_ONBOARD_DIGITAL_RM = 'digital_relationship_manager';
export const USER_ONBOARD_CDP_OFFICER = 'cdp_officers';
export const USER_ONBOARD_CLOSED_LOAN_EDIT_MANAGER = 'closed_loan_edit_manager';



export const USER_ONBOARD_CREDIT_MANAGER = 'credit_manager';
export const USER_ONBOARD_ADMIN_LO = 'adminloanofficer';
export const USER_ONBOARD_COBORROWER = 'coborrower_onboard';
export const USER_ONBOARD_FIRSTDEGREE_ADVISOR = 'first_degree_advisor_onboard';
export const USER_ONBOARD_APPLICANT = 'applicant';
export const USER_ONBOARD_FIRSTDEGREE_APPLICANT = 'first_degree_applicant';
export const USER_ONBOARD_ADMIN_UNDERWRITER = 'adminunderwriter';
export const USER_ONBOARD_ADMIN_ISO = 'adminiso';
export const USER_ONBOARD_UNDERWRITER = 'underwriter';
export const USER_ONBOARD_SALES = 'sales';
export const USER_ONBOARD_SALES_ADMIN = 'sales_admin';
export const USER_ONBOARD_ACCOUNTING = 'accounting';
export const USER_ONBOARD_HIGH_CREST = 'high_crest';
export const USER_ONBOARD_SUPER_ADMIN = 'super_admin';
export const SMARTMATCH_TYPE_REALTOR = 'realtors';
export const USER_ONBOARD_CLOSER = 'closer';
export const USER_ONBOARD_LOAN_OFFICER_BACK_END = 'loanofficer_backend';
export const USER_ONBOARD_LOAN_OFFICER_CARDS_SECURED = 'loan_officer_cards_secured';
export const USER_ONBOARD_LOAN_OFFICER_CREDIT_MANAGER = 'loan_officer_credit_manager';

export const USER_ONBOARD_LOAN_OFFICER_CARDS = 'loan_officer_cards';
export const USER_ONBOARD_LOAN_OFFICER_MORTGAGE = 'loan_officer_mortgage';
export const USER_ONBOARD_LOAN_OFFICER_CONSUMER = 'loan_officer_consumer';
export const USER_ONBOARD_ADMIN_PRODUCTS = 'admin_product_types';
export const AUDITOR = 'auditor'

export const APPLICANT_ROLES = [
  USER_ONBOARD_APPLICANT
];

// TODO: have to remove all this static role names other than admin/applicant

export const ADVISOR_PROFILE_ROLES = [
  USER_ONBOARD_ADMIN,
  USER_ONBOARD_ADMIN_READER,
  USER_ONBOARD_ADMIN_LO,
  USER_ONBOARD_ADMIN_ISO,
  USER_ONBOARD_ADMIN_UNDERWRITER,
  USER_ONBOARD_UNDERWRITER,
  USER_ONBOARD_LOAN_PROCESSOR,
  USER_ONBOARD_LOAN_PROCESSOR_READER,
  USER_ONBOARD_ACCOUNTING,
  USER_ONBOARD_SALES,
  USER_ONBOARD_SALES_ADMIN,
  USER_ONBOARD_LOAN_OFFICER,
  USER_ONBOARD_LOAN_OFFICER_BACK_END,
  USER_ONBOARD_CLOSER,
  USER_ONBOARD_HIGH_CREST,
  USER_ONBOARD_LOAN_OFFICER_CARDS_SECURED,
  USER_ONBOARD_CREDIT_MANAGER,
  USER_ONBOARD_DIGITAL_RM,
  SMARTMATCH_TYPE_RATE_APPROVER,
  USER_ONBOARD_CLOSED_LOAN_EDIT_MANAGER,
  USER_ONBOARD_CDP_OFFICER,
  AUDITOR,

];


export const NON_CHAT_ADVISOR_ROLES = [
  USER_ONBOARD_ISO,
  USER_ONBOARD_LOAN_PROCESSOR,
  USER_ONBOARD_ADMIN_ISO,
];

export const ISO_ROLES = [USER_ONBOARD_ISO, USER_ONBOARD_ADMIN_ISO];

export const ADMIN_ADVISOR_ROLES = [
  USER_ONBOARD_ADMIN_UNDERWRITER,
  USER_ONBOARD_ADMIN_LO,
  USER_ONBOARD_ADMIN_ISO,
];

export const LOAN_STAGES_ACCESS_PERSIMMIONS = [
  USER_ONBOARD_ADMIN_UNDERWRITER,
  USER_ONBOARD_ADMIN,
  USER_ONBOARD_ADMIN_LO,
  USER_ONBOARD_LOAN_PROCESSOR,
  USER_ONBOARD_ACCOUNTING,
  USER_ONBOARD_UNDERWRITER,
  USER_ONBOARD_SALES,
  USER_ONBOARD_SALES_ADMIN,
  USER_ONBOARD_SUPER_ADMIN,
  SMARTMATCH_TYPE_REALTOR,
  USER_ONBOARD_LOAN_OFFICER,
  USER_ONBOARD_CLOSER,
  USER_ONBOARD_ADMIN_ISO,
  USER_ONBOARD_LOAN_OFFICER_CARDS_SECURED
];

export const NOTIFY_EMAIL_PREQUALIFICATION_PASSWORD =
  buildLabel('notify_my_password');

export const verifyAccount = (currentRoles: any, roles: any[]) => {
  return gt(
    length(filter((item: any) => includes(item, roles), currentRoles)),
    0
  );
};
